module.exports = __webpack_public_path__ + "img/logo_gold.dedf7e7b.png";